import { AfterContentInit, Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { LargeurStation } from 'src/app/domain/MPCE/largeur-station';
import { Process } from 'src/app/domain/MPCE/process';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { MPCEService } from 'src/app/services/mpce-service';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { MPCEMGCEMeasureBoxComponent } from 'src/app/tools/ui/mpce-mgce-measure-box/mpce-mgce-measure-box.component';

@Component({
    selector: 'app-ibgn',
    templateUrl: './mpce.component.html',
    styleUrls: ['./mpce.component.scss']
})
export class MPCEComponent implements OnInit, AfterContentInit {
    private MESURE_MAX = 10;
    public COMMENT_MAX_SIZE = 100;
    IsAmontX2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkXAgainstAval(),
        Validators.pattern(/^(\d{6})?$/)]));
    IsAvalX2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkXAgainstAmont(),
        Validators.pattern(/^(\d{6})?$/)]));

    IsAmontY2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkYAgainstAval(),
        Validators.pattern(/^(\d{7})?$/)]));
    IsAvalY2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkYAgainstAmont(),
        Validators.pattern(/^(\d{7})?$/)]));

    public model: Process = new Process();
    private interventionType: EInterventionType;
    private interventionCode: string;
    ValidAmontMaxLength = new UntypedFormControl('', [Validators.maxLength(this.COMMENT_MAX_SIZE)]);
    ValidAvalMaxLength = new UntypedFormControl('', [Validators.maxLength(this.COMMENT_MAX_SIZE)]);

    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'save'
            },
            // {
            //     Id: 1,
            //     Text: undefined,
            //     Icon: 'insert_chart_outlined'
            // }
        ];

    constructor(

        private ChangeNavigationService: ChangeNavigationService,
        private coreData: CoreData,
        private mPCEService: MPCEService,
        private router: Router,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private snackBar: MatSnackBar) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.save(true);
            }
        })
    }

    ngOnInit() {
        if (!this.route.snapshot.params.processCode || !this.route.snapshot.params.interventionCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        this.interventionType = Number(this.route.snapshot.params.type) as EInterventionType;
        this.interventionCode = this.route.snapshot.params.interventionCode;
        this.model.Code = this.route.snapshot.params.processCode;
    }

    ngAfterContentInit(): void {
        const code = this.model.Code;

        if (this.coreData.IsOffline) {
            this.model = this.coreData.getOfflineProcess(code) as Process;
        } else {
            this.mPCEService.getStation(this.model.Code).subscribe(x => {
                this.model = x;
                this.model.Code = code;
            });
        }

        this.ValidAmontMaxLength.markAsTouched();
        this.ValidAvalMaxLength.markAsTouched();
        this.IsAmontX2FarControl.markAsTouched();
        this.IsAvalX2FarControl.markAsTouched();
        this.IsAmontY2FarControl.markAsTouched();
        this.IsAvalY2FarControl.markAsTouched();
        setTimeout(() => {
            this.IsAvalX2FarControl.updateValueAndValidity();
            this.IsAmontX2FarControl.updateValueAndValidity();
            this.IsAvalY2FarControl.updateValueAndValidity();
            this.IsAmontY2FarControl.updateValueAndValidity();
        }, 0);
    }

    canSave() {
        if (this.model.MesureStation.LargeurStations.some(x => x.Lm === null || x.LpB === null || x.Lm === undefined || x.LpB === undefined || x.Lm === 0 || x.LpB === 0)) {
            return false;
        }
        return true;
    }

    onAmontXKeyUpEvent($event) {
        this.IsAvalX2FarControl.updateValueAndValidity();
    }
    onAvalXKeyUpEvent($event) {
        this.IsAmontX2FarControl.updateValueAndValidity();
    }
    onAmontYKeyUpEvent($event) {
        this.IsAvalY2FarControl.updateValueAndValidity();
    }
    onAvalYKeyUpEvent($event) {
        this.IsAmontY2FarControl.updateValueAndValidity();
    }

    checkXAgainstAmont(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.LocalisationStation &&
                !(Math.abs(control.value - this.IsAmontX2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkXAgainstAval(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.LocalisationStation &&
                !(Math.abs(control.value - this.IsAvalX2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkYAgainstAmont(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.LocalisationStation &&
                !(Math.abs(control.value - this.IsAmontY2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkYAgainstAval(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.LocalisationStation &&
                !(Math.abs(control.value - this.IsAvalY2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    getLpB(i) {
        return `Lpb ${i + 1}`;
    }

    getLm(i) {
        return `Lm ${i + 1}`;
    }

    addLargeur() {
        if (this.model.MesureStation.LargeurStations.length < 10) {
            this.model.MesureStation.LargeurStations.push(new LargeurStation());
        }
    }

    removeLargeur(measure: LargeurStation) {
        // if (this.model.MesureStation.LargeurStations.length > 1) {
        //   this.model.MesureStation.LargeurStations.pop();
        // }
        _.remove(this.model.MesureStation.LargeurStations, x => x === measure);
    }

    openMesureBox(largueur?: LargeurStation) {
        if (this.model.MesureStation.LargeurStations.length >= this.MESURE_MAX) {
            NotificationManager.handleWarning(`Le nombre maximal de mesure est de ${this.MESURE_MAX}`, this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(MPCEMGCEMeasureBoxComponent, {
            // data: Object.assign({}, largueur) ?? new LargeurStation(),
            data: {
                mesure: Object.assign({}, largueur) ?? new LargeurStation(),
                type: EInterventionType.MPCE
            },
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: LargeurStation) => {
            if (result) {
                if (!largueur) {
                    this.model.MesureStation.LargeurStations.push(result);
                } else {
                    Object.assign(largueur, result);
                }
            }
        });
    }

    computeLpBMoy() {
        if (this.model.MesureStation.LargeurStations.filter(y => y.LpB > 0).length === 0) {
            return 0;
        }
        return _.sum(this.model.MesureStation.LargeurStations.map(x => x.LpB)) / this.model.MesureStation.LargeurStations.filter(y => y.LpB > 0).length;
    }

    computeLtCalculee() {
        if (this.computeLpBMoy() < 8) {
            return this.computeLpBMoy() * 18;
        } else if (this.computeLpBMoy() >= 8 && this.computeLpBMoy() < 25) {
            return this.computeLpBMoy() * 12;
        } else {
            return this.computeLpBMoy() * 6;
        }
    }

    computeSequence() {
        if (this.computeLpBMoy() < 8) {
            return 3;
        } else if (this.computeLpBMoy() > 8 && this.computeLpBMoy() < 25) {
            return 2;
        } else {
            return 1;
        }
    }

    computeLmMoy() {
        if (this.model.MesureStation.LargeurStations.filter(y => y.LpB > 0).length === 0) {
            return 0;
        }
        return _.sum(this.model.MesureStation.LargeurStations.map(x => x.Lm)) / this.model.MesureStation.LargeurStations.filter(y => y.LpB > 0).length;
    }

    computeSmouille() {
        return this.model.MesureStation.LtReelle * this.computeLmMoy();
    }

    computeLineaireParcouru() {
        return this.model.MesureStation.LpbEstimee * 30;
    }

    computeSmaxMarg() {
        return this.computeSmouille() * 5 / 100;
    }

    async save(forced: boolean) {
        let hasRecordAComment = false;
        if (!forced && this.coreData.IsOffline && (this.model.MesureStation.LtReelle < this.computeLtCalculee() * 0.75 || this.model.MesureStation.LtReelle > this.computeLtCalculee() * 1.25)) {

            const m: ConfirmBoxModel = new ConfirmBoxModel();
            m.QuestionTitle = 'Ecart de plus de 25% entre la longueur réelle et la longueur théorique, merci de justifier';
            m.WithReason = true;
            const int = this.coreData.getOfflineIntervention(this.interventionCode);
            //m.Reason = this.model.MesureStation.LtReelle < this.computeLtCalculee() * 0.75 ? 'Longueur de station raccourcie :' : 'Longueur de station allongée :'
            m.Reason = int?.Tracabilite?.Comment !== undefined ? int.Tracabilite.Comment : null;
            const dialogRef = this.dialog.open(ConfirmBoxDialog, {
                data: m,
                width: '777px',
                disableClose: true
            });

            await dialogRef.afterClosed().toPromise().then((result: ConfirmBoxModel) => {
                if (result) {
                    const int = this.coreData.getOfflineIntervention(this.interventionCode);
                    int.Tracabilite.Comment = result.Reason
                    this.coreData.setOfflineIntervention(int)
                    hasRecordAComment = true
                }
            })
            if (!hasRecordAComment) {
                NotificationManager.handleWarning('Vous devez saisir un commentaire concernant la longueur de la station', this.snackBar);
                return;
            }
        }

        if (this.canSave() || forced) {
            if (this.coreData.IsOffline) {
                this.coreData.setOfflineProcess(this.model);
            } else {
                this.mPCEService.updateStation(this.model).subscribe(x => {
                    NotificationManager.handleSuccess('Mesure station mise à jour', this.snackBar);
                });
            }
        } else {
            NotificationManager.handleWarning('Merci de remplir ou de supprimer les longueurs inutilisées ', this.snackBar);
        }
    }

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            case 0:
                this.save(false);
                break;
            // case 1:
            //     this.router.navigate([ENavigationRoute.PlanPrelevement, { processCode: this.model.Code, type: this.interventionType }]);
            //     break;
        }
    }
}
